/**
 * @ngdoc filters
 * @memberof mercury.filters
 * @name toArray
 */
angular.module('mercury.filters.toarray', [])
.filter('toArray', function() {
  return function(obj) {
    var result = [];
    angular.forEach(obj, function(val) {
      result.push(val);
    });
    return result;
  };
});
